import { render, staticRenderFns } from "./login-box.vue?vue&type=template&id=3bfd0458&scoped=true"
import script from "./login-box.vue?vue&type=script&lang=js"
export * from "./login-box.vue?vue&type=script&lang=js"
import style0 from "./login-box.vue?vue&type=style&index=0&id=3bfd0458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd0458",
  null
  
)

export default component.exports